import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['permissionsSection'];
    static values = { role: String };

    declare readonly permissionsSectionTarget: HTMLElement;
    declare readonly roleValue: string;

    connect(): void {
        this.updateVisibility(this.roleValue);
    }

    togglePermissions(event: Event): void {
        const select = event.target as HTMLSelectElement;
        this.updateVisibility(select.value);
    }

    private updateVisibility(role: string): void {
        if (role === 'USER') {
            this.permissionsSectionTarget.style.display = '';
        } else {
            this.permissionsSectionTarget.style.display = 'none';
        }
    }
}
